import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowDown } from "lucide-react";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-end overflow-hidden"
      style={{ backgroundColor: "#F7F5F0" }}
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-30 pointer-events-none"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1618763604262-6cbefa2a7b8e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHxtaW5pbWFsJTIwYWJzdHJhY3QlMjB0ZXh0dXJlJTIwc2FuZHxlbnwwfHx8fDE3ODA4NDA4NTF8MA&ixlib=rb-4.1.0&q=85')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          mixBlendMode: "multiply",
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-40 pb-24 md:pb-32 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 w-full">
        <div className="md:col-span-2 hidden md:block">
          <p className="overline anchor-fade-up">01 — Begin</p>
        </div>

        <div className="md:col-span-8">
          <p className="overline mb-8 md:hidden">01 — Begin</p>
          <h1
            data-testid="hero-headline"
            className="serif text-5xl sm:text-6xl md:text-7xl lg:text-8xl tracking-tight text-[#15243D] leading-[1.02] anchor-fade-up"
            style={{ fontWeight: 300, animationDelay: "0.1s" }}
          >
            How not to<br />
            become the <em className="italic text-[#C07865]">storm.</em>
          </h1>

          <p
            className="mt-10 max-w-xl text-lg md:text-xl font-light leading-relaxed text-[#5A5D63] anchor-fade-up"
            style={{ animationDelay: "0.4s" }}
            data-testid="hero-subheadline"
          >
            Life will always bring waves — stress, uncertainty, conflict,
            change. Anchor teaches you how to pause, return to the present
            moment, and respond from clarity instead of reaction.
          </p>

          <div
            className="mt-12 flex flex-col sm:flex-row gap-4 anchor-fade-up"
            style={{ animationDelay: "0.7s" }}
          >
            <Link
              to="/apply"
              data-testid="hero-apply-button"
              className="btn-primary"
            >
              Apply for coaching
              <ArrowUpRight size={16} strokeWidth={1.5} />
            </Link>
            <a
              href="#program"
              data-testid="hero-program-button"
              className="btn-secondary"
            >
              Get the 28-day program
            </a>
          </div>
        </div>

        <div
          className="md:col-span-2 hidden md:flex items-end justify-end anchor-fade-up"
          style={{ animationDelay: "1s" }}
        >
          <div className="flex flex-col items-end gap-2 text-xs tracking-[0.2em] uppercase text-[#8A8D93]">
            <ArrowDown size={16} strokeWidth={1.25} />
            Scroll
          </div>
        </div>
      </div>
    </section>
  );
}
